$(document).ready(function () {
  $(".component-slideshow__slider").each(function () {
    const $slider = $(this);
    const autoplay = $slider.data("autoplay"); // récupère data-autoplay="true" du HTML

    $slider.flickity({
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      autoPlay: autoplay ? 4000 : false // active autoplay si data-autoplay est true
    });
  });
});